import { makeStyles } from 'tss-react/mui';

import { menuItemClasses, outlinedInputClasses, selectClasses } from '@mui/material';

import macOsScrollBar from 'main/theme/mac-os-scrollbar';

export default makeStyles<void, '_inverted'>({ name: 'Select' })((_, __, classes) => ({
    menu: {
        marginTop: 4
    },
    paper: {
        ...macOsScrollBar(),
        scrollbarGutter: 'auto',
        padding: 8,
        maxHeight: 300
    },
    list: {
        padding: '0 !important',
        boxSizing: 'border-box',
        [`& .${menuItemClasses.root}`]: {
            fontWeight: 400,
            fontSize: 13,
            lineHeight: '16px',
            color: '#38383A',
            padding: '12px 24px 12px 16px',
            borderRadius: 8
        },
        [`& .${menuItemClasses.selected}`]: {
            background: '#F5F5F5 !important'
        }
    },
    root: {
        color: '#232323',
        fontSize: 13,
        fontWeight: 500,
        lineHeight: '16px',
        background: 'transparent',
        [`& .${outlinedInputClasses.notchedOutline}`]: {
            borderRadius: 8,
            border: '1px solid #ECECEC !important'
        },
        [`&.${classes._inverted} .${outlinedInputClasses.notchedOutline}`]: {
            borderRadius: 8,
            border: '1px solid #353535 !important'
        }
    },
    large: {
        padding: '12px 0 12px 16px !important'
    },
    medium: {
        padding: '8px 0 8px 12px !important'
    },
    small: {
        padding: '4px 0 4px 4px !important'
    },
    select: {
        minHeight: 'unset !important',
        padding: '0 32px 0 0 !important',
        textAlign: 'center',
        '&:focus': {
            borderRadius: 8,
            backgroundColor: 'transparent'
        },
        [`&.${classes._inverted}`]: {
            color: '#fff',
            [`&.${selectClasses.disabled}`]: {
                WebkitTextFillColor: 'rgba(255, 255, 255, 0.38)'
            }
        }
    },
    icon: {
        transition: 'transform 0.2s',
        [`&.${classes._inverted}`]: {
            color: '#8E8E8E'
        }
    },
    _inverted: {}
}));
